"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePaymentSchema = void 0;
const zod_1 = require("zod");
const PaymentPurposeType_1 = require("../enums/PaymentPurposeType");
const constants_1 = require("../constants");
const numbers_1 = require("../numbers");
exports.impossiblePaymentSchema = zod_1.z.object({
    date: zod_1.z.string().regex(constants_1.REGEX.iso8601Date),
    amount: zod_1.z.number().min(1).max((0, numbers_1.million)(5)).nullable(),
    purpose: zod_1.z.nativeEnum(PaymentPurposeType_1.PaymentPurposeType).nullable(),
    purposeRaw: constants_1.defaultOptionalString,
}).strict();
